import React, { ReactNode, useState } from "react"
import _ from "lodash"
import "./DebugView.scss"

export interface DebugViewProps {
  name: string,
  state?: [name: string, val: ReactNode | string][],
  actions?: [name: string, callback: () => void][],
  logs?: {ts: Date, msg: string, key: number}[],
}

export const boolVal = (val?: boolean) => val ? "✔" : "✕"

export const busyVal = (val?: boolean) => val ? "⌛" : "-"

export const useDebugLogs = () => {
  const [ logs, setLogs ] = useState<DebugViewProps["logs"]>([])
  return {
    logs,
    addLog: (log: string) => setLogs((prev) => [...(prev || []), {ts: new Date(), msg: log, key: (prev || []).length + 1}])
  }
}

const DebugView: React.FC<DebugViewProps> = ({ name, actions, logs, state}) => {
  return <div className="neo__debugView">
    <h3 className="neo__debugView__title">{name}</h3>
    <div className="neo__debugView__content">
      <div>
        <h4>State</h4>
        {_.map(state, (state, index) => {
          return <div key={index}>
            <span>ⓘ {state[0]}</span>
            {" "}
            <strong>{state[1]}</strong>
          </div>
        })}
      </div>
      <div>
        <h4>Actions</h4>
        {_.map(actions, (action, index) => {
          return <div key={index}>
            ⚡︎ <a onClick={action[1]}>{action[0]}</a>
          </div>
        })}
      </div>
      <div>
        <h4>Logs</h4>
        <div className="neo__debugView__logs">
          {_.map(_.reverse(logs || []), (log) => {
            return <div key={log.key}>
              <span>{`${log.ts.getHours()}:${log.ts.getMinutes()}:${log.ts.getSeconds()}`}</span>
              {" "}
              <strong>{log.msg}</strong>
            </div>
          })}
        </div>
      </div>
    </div>
  </div>
}

export default DebugView
